import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate, useLocation } from 'react-router-dom';

import axios from '../util/Api.js';
import PaymentOptions from '../components/PaymentOptions.js';

export default function Home() {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const [evseId, setEvseId] = React.useState('');
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const { evseId: fwdId, errMsg } = location.state || {};
    if (fwdId) {
      setEvseId(fwdId);
      setError(intl.formatMessage({ id: errMsg }));
    }
  }, [intl, location]);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!evseId.trim()) {
      setError(intl.formatMessage({ id: 'home.error.evseidmissing' }));
      return;
    }
    setLoading(true);
    setError(null);
    axios
      .get(`evses/${evseId}`)
      .then(({ data }) => {
        if (data.id) {
          navigate('/checkout/' + evseId);
        } else {
          setError(intl.formatMessage({ id: data.message || 'global.error.generic' }));
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(intl.formatMessage({ id: err.response?.data?.detail || 'global.error.generic' }));
        setLoading(false);
      });
  };

  return (
    <div className="min-h-screen w-full bg-brand-gradient flex items-center justify-center p-6">
      <div className="w-full max-w-md flex flex-col items-center">
        {/* Branding */}
        <div className="mb-8 text-center">
          <h1 className="text-5xl font-black text-white tracking-tight leading-tight">
            Scan. Pay.
          </h1>
          <h1 className="text-5xl font-black text-accent tracking-tight">
            Charge.
          </h1>
        </div>

        {/* Subtitle */}
        <p className="text-white/70 text-center mb-6 text-sm">
          {intl.formatMessage({ id: 'home.subheading' })}
        </p>

        {/* Payment icons */}
        <div className="w-full mb-8">
          <PaymentOptions size={32} />
        </div>

        {/* Instructions */}
        <p className="text-white/50 text-center text-xs mb-6 px-4">
          {intl.formatMessage({ id: 'home.instructions' })}
        </p>

        {/* Form */}
        <form onSubmit={onSubmit} className="w-full space-y-4">
          <div>
            <label className="block text-white/60 text-xs font-semibold mb-2 uppercase tracking-wider">
              EVSE ID
            </label>
            <input
              type="text"
              value={evseId}
              onChange={(e) => { setEvseId(e.target.value); setError(null); }}
              placeholder="ES*TEST*E0001"
              className="glass-input"
            />
            {error && (
              <p className="text-danger text-sm mt-2 text-center">{error}</p>
            )}
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary flex items-center justify-center gap-2"
          >
            {loading ? (
              <i className="ri-loader-4-line animate-spin"></i>
            ) : (
              <i className="ri-flashlight-line"></i>
            )}
            {intl.formatMessage({ id: 'global.continue' })}
          </button>
        </form>
      </div>
    </div>
  );
}
